<template>
  <form-filtered-select
    :selected-key="selectedCustomer ? selectedCustomer.value : null"
    :options="customerOptions"
    :invalid="invalid"
    placeholder="Customer"
    @updateDropdownValue="onUpdateValue"
    @close="$emit('close')" />
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedCustomer: null
    }
  },
  computed: {
    ...mapState('customer', ['customerOptions'])
  },
  watch: {
    value: function () {
      if (this.selectedCustomer && this.value.value !== this.selectedCustomer.value) {
        this.selectedCustomer = this.value
      }
    }
  },
  mounted () {
    this.selectedCustomer = this.value
    this.$watch('selectedCustomer', function () {
      this.$emit('input', this.selectedCustomer)
    })
  },
  methods: {
    onUpdateValue (value) {
      this.selectedCustomer = value
    }
  }
}
</script>

<style>

</style>

<style></style>
